export const routes = (prefix = `billing`, pref = `consultant-dashboard`) => [
    {
        path: `/${prefix}/${pref}/payment`,
        name: `${prefix}.${pref}.payment.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pref}.payment.create`,
                PageDescription: "Consultant Payment: Payment",
            },
        },
    },
];
